"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var renderToHTML = function renderToHTML(Component) {
  return new Promise(function (resolve) {
    var span = document.createElement('span');
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(Component, null), span, function () {
      var html = span.innerHTML;
      span.remove();
      resolve(html);
    });
  });
};
var _default = exports.default = renderToHTML;